import React, {Component} from 'react';
import swal from 'sweetalert';
import moment from 'moment';
import {translate} from 'react-i18next';
import { Card, CardContent } from '@material-ui/core';
import { LineChart, CartesianGrid, XAxis, YAxis, Legend, Tooltip, Line, ResponsiveContainer, PieChart, Pie, Cell, BarChart, Bar } from 'recharts';
import $, { data } from 'jquery';
import {  donationTypeExtraction, statisticalSummaryOfDonors} from '../../../../libs/services';


var session = sessionStorage.getItem('health_facilities_name');
const Config = require('../../../../config');


//import {makeStyles, Card } from '@material-ui';

class StatisticalSummaryOfDonors extends Component{
	
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.checking = this.checking.bind(this);

		this.getConvokePlace = this.getConvokePlace.bind(this);
		this.getDonationsType = this.getDonationsType.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

		this.state = {

			health_facilities_id:"all",
			health_facilities: [],
			health_facilities_name:"all",
			extraction_type_id:"all",
			extraction_type:[],

			donation_type_id:"all",
			donations_type:[],

			convoke_places:[],
			convoke_places_id:"all",

			genero:"all",

			status_clinic_history:"all",
			status_extraction:"all",

			change_check: false,
			start_date 	: "",
			end_date 	: "",
			extraction_type_name:"",
			donation_type_name:"",
			convoke_places_name:"",

			data: [],
			total:0,
			dataSexo:[],
			dataTypeExtraction:[],
			dataTypeDonation:[],
			dataStatusHC:[],
			dataStatusEx:[],
			dataCenter:[],
			filename:"Resumen Estadistico Donadores",
			colorArray: [
				'#FF6633', '#FFB399', '#E6B3B3','#CC9999', 
				'#E6B333', '#ebdf3fff', '#CCCC00','#E6FF80', 
				'#3366E6','#4444e0ff','#4D80CC','#6680B3', '#00B3E6', '#4DB3FF', '#99E6E6',
				'#B34D4D','#d4340cff', '#E6331A', '#FF1A66', '#E64D66', 
				'#9900B3', '#991AFF', '#B366CC', 
				'#FF33FF', '#FF3380', '#E666FF', '#E666B3', '#CC80CC', '#FF99E6', 
				'#66664D', '#999966', 
				'#33991A','#66991A', '#4D8000','#66994D','#4D8066', '#809980', '#80B300','#809900','#99FF99', , '#4DB380','#999933','#B3B31A',
				'#33FFCC','#1AFF33', '#66E64D','#00E680','#1AB399','#CCFF1A'
				]
		}
	}

	async componentDidMount(){
	
			fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
				method: 'get',
				headers: new Headers({
				   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				   'Accept': 'application/json',
					'Content-Type': 'application/json',
				})
			})
			.then(response => response.json())
			.then(response => {
				var aux = response.split('|');
				var date = aux[0].split("/");
				var hours = this.getHourFormat(aux[1]);
	
				this.setState({
					start_date:date[2]+'-'+date[1]+'-'+date[0],
					end_date:date[2]+'-'+date[1]+'-'+date[0],
					date_hour:aux[0]+' '+hours,
				});
			})
		
				fetch(Config.default.apiGateway.URL+'health_facilities', {
					method: 'GET',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.setState({
							health_facilities: response
						});
					}
				});
		
				this.getConvokePlace();
		
				let aux_resp = await donationTypeExtraction("no_cells");
				if(aux_resp !== undefined){
					this.setState({
						extraction_type: aux_resp
					});
				}
		
				this.getDonationsType();
	}

	checking(e){
		if(this.state.change_check){
			this.setState({
				change_check: false,
				health_facilities_id:'all'// sessionStorage.getItem('health_facilities_id'),
			});
		}else{
			this.setState({
				change_check: true,
			});
		}
	}
	createData(data, elemento){

		const dataList = data.reduce((acc, item) => {
			const name = item.elemento || 'SIN DATOS';

			if (!acc[name]) {
				acc[name] = { name, total: 0 };
			}

			acc[name].total += Number(item.TOTAL || 0);

			return acc;
			}, {});

			// convierte en object el resultado 
			const pieSexoData = Object.values(dataList);

	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		var control = document.getElementById(e.target.name);
		
		if(control.required && control.className.includes('error')){
			control.classList.remove('error');
		}

		if(e.target.name === 'health_facilities_id'){
			setTimeout(()=>{
				this.getConvokePlace();
			}, 500);
			this.setState({
				health_facilities_name:e.target.options[e.target.selectedIndex].text
			})	
		}else if(e.target.name === 'convoke_places_id'){
			this.setState({
				convoke_places_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'extraction_type_id'){
			this.setState({
				extraction_type_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'donation_type_id'){
			this.setState({
				donation_type_name: e.target.options[e.target.selectedIndex].text
			})
		}
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}


	async searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){

				var obj = {
					gender:this.state.genero,
					extraction_type_id:this.state.extraction_type_id,
					donation_type_id:this.state.donation_type_id,
					health_facilities_id:this.state.health_facilities_name,
					status_clinic_history:this.state.status_clinic_history,
					status_extraction:this.state.status_extraction,
					start_date:this.state.start_date,
					end_date:this.state.end_date,
				};


				var response = await statisticalSummaryOfDonors(obj);
				if(response !== undefined){

					// calcula el total de las donaciones	
					const sumaTotal = response.reduce((acc, item) => acc + Number(item.TOTAL || 0), 0);

					//calcula y agrupa por genero
					//#region 
					const dataBySexo = response.reduce((acc, item) => {
					const sexo = item.SEXO || 'SIN DATOS';

					if (!acc[sexo]) {
						acc[sexo] = { sexo, total: 0 };
					}

					acc[sexo].total += Number(item.TOTAL || 0);

					return acc;
					}, {});

					// convierte en object el resultado 
					const pieSexoData = Object.values(dataBySexo);
					//#endregion
					
					//calcula y agrupa por TIPO DE EXTRACCION
					//#region 
					const dataByTypeExtraction = response.reduce((acc, item) => {
					const te = item.TIPO_EXTRACCION || 'SIN DATOS';

					if (!acc[te]) {
						acc[te] = { te, total: 0 };
					}

					acc[te].total += Number(item.TOTAL || 0);

					return acc;
					}, {});

					// convierte en object el resultado 
					const pieTypeExtractionData = Object.values(dataByTypeExtraction);
					//#endregion

					//calcula y agrupa por TIPO DE DONACION
					//#region 
					const dataByTypeDonation = response.reduce((acc, item) => {
					const td = item.TIPO_DONACION.replace(/^DONACION?/, "").replace(/_/g," ") || 'SIN DATOS';

					if (!acc[td]) {
						acc[td] = { td, total: 0 };
					}
					acc[td].total += Number(item.TOTAL || 0);

					return acc;
					}, {});
					

					// convierte en object el resultado 
					const pieTypeDonationData = Object.values(dataByTypeDonation);
					//#endregion

					//calcula y agrupa por ESTATUS DE HISTORIA CLINICA
					//#region 
					const dataByStatusHC = response.reduce((acc, item) => {
					const ehc = item.ESTATUS_HC|| 'SIN DATOS';

					if (!acc[ehc]) {
						acc[ehc] = { ehc, total: 0 };
					}

					acc[ehc].total += Number(item.TOTAL || 0);

					return acc;
					}, {});

					// convierte en object el resultado 
					const pieStatusHCData = Object.values(dataByStatusHC);
					//#endregion

					//calcula y agrupa por ESTATUS DE EXTRACCION
					//#region 
					const dataByStatusEX = response.reduce((acc, item) => {
					const eex = item.ESTATUS_EX|| 'SIN DATOS';

					if (!acc[eex]) {
						acc[eex] = { eex, total: 0 };
					}

					acc[eex].total += Number(item.TOTAL || 0);

					return acc;
					}, {});

					// convierte en object el resultado 
					const pieStatusEXData = Object.values(dataByStatusEX);
					//#endregion

					//calcula y agrupa por CENTRO
					//#region 
					const dataBycenter = response.reduce((acc, item) => {
					const center = item.CENTRO|| 'SIN DATOS';

					if (!acc[center]) {
						acc[center] = { center, total: 0 };
					}

					acc[center].total += Number(item.TOTAL || 0);

					return acc;
					}, {});

					// convierte en object el resultado 
					const pieCenterData = Object.values(dataBycenter);
					//#endregion



					this.setState({
						data:response,
						total:sumaTotal,
						dataSexo:pieSexoData,
						dataTypeExtraction:pieTypeExtractionData,
						dataTypeDonation:pieTypeDonationData,
						dataStatusHC:pieStatusHCData,
						dataStatusEx:pieStatusEXData,
						dataCenter:pieCenterData
						
					});
				}
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
		
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		} 

	}

	getConvokePlace(){
 		var health = this.state.health_facilities_id;
 		
 		if(sessionStorage.getItem('matriz') === '1' && health === sessionStorage.getItem('health_facilities_id')){
 			health = 'all';
 		}

 		fetch(Config.default.apiGateway.URL+'convoke_places/by_hf?health_facilities_id='+health, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					convoke_places: response
				});
			}
		});
 	}

 	getDonationsType(){
 		fetch(Config.default.apiGateway.URL+'donation_type/actives', {
 			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
 		}).then(res => {
 			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					donations_type: response
				});
			}
		});
 	}
	
	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}
	dateCompare(){
			var ini = moment(this.state.start_date);
			var fin = moment(this.state.end_date);
			var date_ok = true;
	
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
	
			return date_ok;
		}


	render(){
		const {t} = this.props;

		return(
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Donantes ->
					RESUMEN ESTADISTICO DONADORES
					</h5>
				</div>
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className='col-xs-12'>
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Centro</span>
									<select type="text" name="health_facilities_id" id="health_facilities_id" 
										value={this.state.health_facilities_id} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.health_facilities.map((h, i)=>{
											return <option key={i} value={h.id}>
												{h.name}
											</option>
										})}
									</select>

									{/* <input type="checkbox" name="change_center" id="change_center" 
										style={{marginRight:"5px"}} onChange={this.checking}
										checked={this.state.change_check} />
									<span className="span-min">Cambiar</span> */}
								</div>
								{/* <div className="form-group">
									<span className="span-min">Lugar de Colecta</span>
									<select className="form-control" name="convoke_places_id" id="convoke_places_id"
										value={this.state.convoke_places_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.convoke_places.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>
								</div> */}
								<div className="form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Género</span>
									<select className="form-control" name="genero" id="genero"
										value={this.state.genero} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										<option value="HOMBRE">HOMBRE</option>
										<option value="MUJER">MUJER</option>
										
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Tipo de Extracción</span>
									<select className="form-control" name="extraction_type_id" id="extraction_type_id"
										value={this.state.extraction_type_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.extraction_type.map((don, i)=>{
											return <option key={i} value={don.donation_type_process}>
												{don.donation_type_process}
											</option>
										})}
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Tipo de Donación</span>
									<select className="form-control"  name="donation_type_id" id="donation_type_id"
										value={this.state.donation_type_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.donations_type.map((d, i)=>{
											return <option key={i} value={d.lookup_value}>
												{d.lookup_value}
											</option>
										})}
									</select>
								</div>
									<div className="form-group">
									<span className="span-min">Estatus de Historia Clinica</span>
									<select className="form-control" name="status_clinic_history" id="status_clinic_history"
										value={this.state.status_clinic_history} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										<option value="APTO">APTO</option>
										<option value="NO APTO">NO APTO</option>
										
									</select>
								</div>
									<div className="form-group">
									<span className="span-min">Estatus de Extracción</span>
									<select className="form-control" name="status_extraction" id="status_extraction"
										value={this.state.status_extraction} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										<option value="EXTRAIDO">EXTRAIDO</option>
										<option value="PENDIENTE">PENDIENTE</option>
										
									</select>
								</div>
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} 
										style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>
							
							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline", fontSize:'16px'}}>
									<span>
										{this.state.filename}
									</span>
								</div>
							
						
							<div className="col-xs-12 form-group daily-don" style={{marginTop:'1%'}}>
								<div className="col-xs-12" style={{textAlign:'center'}}>
									<h3>Total de Registros (Ofrecimientos)</h3>
									<h1>{this.state.total}</h1>
								</div>
							</div>

							<div className="col-xs-12">
								{/* DOnacion por Genero */}
							
								<div className="col-xs-4 form-group daily-don">
									<Card variant="outlined">
										<CardContent>
										<h3 style={{ textAlign: "center" }}>
											Ofrecimientos por Género
										</h3>

										<div style={{ display: "flex", alignItems: "center", height: 300 }}>
											
											{/* GRÁFICA */}
											<div style={{ flex: 1, height: "100%" }}>
											<ResponsiveContainer width="100%" height="100%">
												<PieChart>
												<Pie
													data={this.state.dataSexo}
													dataKey="total"
													nameKey="sexo"
													cx="50%"
													cy="50%"
													outerRadius="75%"
												>
													{this.state.dataSexo.map((entry, i) => (
													<Cell
														key={`cell-${i}`}
														fill={
														this.state.colorArray[
															i  % this.state.colorArray.length
														]
														}
													/>
													))}
												</Pie>
												<Tooltip />
												</PieChart>
											</ResponsiveContainer>
											</div>

											{/* LEGEND */}
											<div style={{ width: 180 }}>
											<ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
												{this.state.dataSexo.map((item, i) => (
												<li key={i} style={{ marginBottom: 8 }}>
													<span
													style={{
														display: "inline-block",
														width: 10,
														height: 10,
														backgroundColor:
														this.state.colorArray[
															i % this.state.colorArray.length
														],
														marginRight: 8,
														borderRadius: "50%"
													}}
													/>
													<strong>{item.sexo}</strong>
													<span style={{ marginLeft: 6, color: "#666" }}>
													{item.total}
													</span>
												</li>
												))}
											</ul>
											</div>
										</div>
										</CardContent>
									</Card>
								</div>

								{/* DOnacion por tipo de extraccion */}
								
								{/* <div className="col-xs-4 form-group daily-don">
									<div className="col-xs-12  pie-graph">
										<Card variant="outlined">
											<CardContent className="">                           
												<div className="col-xs-12" style={{textAlign:'center'}}>
													<h3>Donaciones por Tipo de Extracción</h3>
													<div className="col-xs-12">
														<ResponsiveContainer width={$('.pie-graph').width() - 100} height={300}>
															<PieChart width={730} height={250}>
																<Pie 
																	data={this.state.dataTypeExtraction} 
																	dataKey="total" 
																	nameKey="te" 
																	cx="50%" 
																	cy="50%" 
																	outerRadius={100} 
																>
																{this.state.dataTypeExtraction.map((entry, i)=>{
																	return (
																		<Cell
																		key={`cell-${i}`}
																		fill={this.state.colorArray[8 + i]}
																		/>
																		);
																	})}
																</Pie>
																<Tooltip />
															</PieChart>
														</ResponsiveContainer>
													</div>

												</div>
											</CardContent>
										</Card>
									</div>
								</div>  */}

								<div className="col-xs-4 form-group daily-don">
									<Card variant="outlined">
										<CardContent>
										<h3 style={{ textAlign: "center" }}>
											Ofrecimientos por Tipo de Extracción
										</h3>

										<div style={{ display: "flex", alignItems: "center", height: 300 }}>
											<div style={{ flex: 1, height: "100%" }}>
											<ResponsiveContainer width="100%" height="100%">
												<PieChart>
												<Pie
													data={this.state.dataTypeExtraction}
													dataKey="total"
													nameKey="te"
													cx="50%"
													cy="50%"
													outerRadius="75%"
												>
													{this.state.dataTypeExtraction.map((entry, i) => (
													<Cell
														key={`cell-${i}`}
														fill={
														this.state.colorArray[
															(8+i) % this.state.colorArray.length
														]
														}
													/>
													))}
												</Pie>
												<Tooltip />
												</PieChart>
											</ResponsiveContainer>
											</div>

											{/* LEGEND */}
											<div style={{ width: 180 }}>
											<ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
												{this.state.dataTypeExtraction.map((item, i) => (
												<li key={i} style={{ marginBottom: 8 }}>
													<span
													style={{
														display: "inline-block",
														width: 10,
														height: 10,
														backgroundColor:
														this.state.colorArray[
															(8+i) % this.state.colorArray.length
														],
														marginRight: 8,
														borderRadius: "50%"
													}}
													/>
													<strong>{item.te}</strong>
													<span style={{ marginLeft: 6, color: "#666" }}>
													{item.total}
													</span>
												</li>
												))}
											</ul>
											</div>
										</div>
										</CardContent>
									</Card>
								</div>

								
								{/* DOnacion por tipo de donacion */}
								
								<div className="col-xs-4 form-group daily-don">
									<Card variant="outlined">
										<CardContent>
										<h3 style={{ textAlign: "center" }}>
											Ofrecimientos por Tipo de Donación
										</h3>

										<div style={{ display: "flex", alignItems: "center", height: 300 }}>
											<div style={{ flex: 1, height: "100%" }}>
											<ResponsiveContainer width="100%" height="100%">
												<PieChart>
												<Pie
													data={this.state.dataTypeDonation}
													dataKey="total"
													nameKey="td"
													cx="50%"
													cy="50%"
													outerRadius="75%"
												>
													{this.state.dataTypeDonation.map((entry, i) => (
													<Cell
														key={`cell-${i}`}
														fill={
														this.state.colorArray[
															(3*i) % this.state.colorArray.length
														]
														}
													/>
													))}
												</Pie>
												<Tooltip />
												</PieChart>
											</ResponsiveContainer>
											</div>

											{/* LEGEND */}
											<div style={{ width: 180 }}>
											<ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
												{this.state.dataTypeDonation.map((item, i) => (
												<li key={i} style={{ marginBottom: 8 }}>
													<span
													style={{
														display: "inline-block",
														width: 10,
														height: 10,
														backgroundColor:
														this.state.colorArray[
															(3*i) % this.state.colorArray.length
														],
														marginRight: 8,
														borderRadius: "50%"
													}}
													/>
													<strong>{item.td}</strong>
													<span style={{ marginLeft: 6, color: "#666" }}>
													{item.total}
													</span>
												</li>
												))}
											</ul>
											</div>
										</div>
										</CardContent>
									</Card>
								</div>
							</div>
							
							<div className="col-xs-12">
								{/* DOnacion por historia clinica */}
								<div className="col-xs-4 form-group daily-don">
									<Card variant="outlined">
										<CardContent>
										<h3 style={{ textAlign: "center" }}>
											Ofrecimientos Estatus de Historia Clínica
										</h3>

										<div style={{ display: "flex", alignItems: "center", height: 300 }}>
											<div style={{ flex: 1, height: "100%" }}>
											<ResponsiveContainer width="100%" height="100%">
												<PieChart>
												<Pie
													data={this.state.dataStatusHC}
													dataKey="total"
													nameKey="ehc"
													cx="50%"
													cy="50%"
													outerRadius="75%"
												>
													{this.state.dataStatusHC.map((entry, i) => (
													<Cell
														key={`cell-${i}`}
														fill={
														this.state.colorArray[
															(4+i) % this.state.colorArray.length
														]
														}
													/>
													))}
												</Pie>
												<Tooltip />
												</PieChart>
											</ResponsiveContainer>
											</div>

											{/* LEGEND */}
											<div style={{ width: 180 }}>
											<ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
												{this.state.dataStatusHC.map((item, i) => (
												<li key={i} style={{ marginBottom: 8 }}>
													<span
													style={{
														display: "inline-block",
														width: 10,
														height: 10,
														backgroundColor:
														this.state.colorArray[
															(4+i) % this.state.colorArray.length
														],
														marginRight: 8,
														borderRadius: "50%"
													}}
													/>
													<strong>{item.ehc}</strong>
													<span style={{ marginLeft: 6, color: "#666" }}>
													{item.total}
													</span>
												</li>
												))}
											</ul>
											</div>
										</div>
										</CardContent>
									</Card>
								</div>

								{/* DOnacion por estatus de extraccion */}
								<div className="col-xs-4 form-group daily-don">
									<Card variant="outlined">
										<CardContent>
										<h3 style={{ textAlign: "center" }}>
											Ofrecimientos por Estatus de Extracción
										</h3>

										<div style={{ display: "flex", alignItems: "center", height: 300 }}>
											
											{/* GRÁFICA */}
											<div style={{ flex: 1, height: "100%" }}>
											<ResponsiveContainer width="100%" height="100%">
												<PieChart>
												<Pie
													data={this.state.dataStatusEx}
													dataKey="total"
													nameKey="eex"
													cx="50%"
													cy="50%"
													outerRadius="75%"
												>
													{this.state.dataStatusEx.map((entry, i) => (
													<Cell
														key={`cell-${i}`}
														fill={
														this.state.colorArray[
															(i + 20) % this.state.colorArray.length
														]
														}
													/>
													))}
												</Pie>
												<Tooltip />
												</PieChart>
											</ResponsiveContainer>
											</div>

											{/* LEGEND */}
											<div style={{ width: 180 }}>
											<ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
												{this.state.dataStatusEx.map((item, i) => (
												<li key={i} style={{ marginBottom: 8 }}>
													<span
													style={{
														display: "inline-block",
														width: 10,
														height: 10,
														backgroundColor:
														this.state.colorArray[
															(i + 20) % this.state.colorArray.length
														],
														marginRight: 8,
														borderRadius: "50%"
													}}
													/>
													<strong>{item.eex}</strong>
													<span style={{ marginLeft: 6, color: "#666" }}>
													{item.total}
													</span>
												</li>
												))}
											</ul>
											</div>

										</div>
										</CardContent>
									</Card>
									</div>
								
								{/* ofrecimientos por hospital */}
								<div className="col-xs-4 form-group daily-don">
									<Card variant="outlined">
										<CardContent>
										<h3 style={{ textAlign: "center" }}>
											Ofrecimientos por Hospital
										</h3>

										<div style={{ display: "flex", alignItems: "center", height: 300 }}>
											<div style={{ flex: 1, height: "100%" }}>
											<ResponsiveContainer width="100%" height="100%">
												<BarChart
													//style={{ width: '100%', maxWidth: '700px', maxHeight: '70vh', aspectRatio: 1.618 }}
													//responsive
													//  width={730}
													//  height={300}
													data={this.state.dataCenter}
													margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
													>
													<CartesianGrid strokeDasharray="3 3" />
													<XAxis dataKey="center" />
													<YAxis />
													<Tooltip />
													{/* <Legend /> */}
													<Bar dataKey="total">
														{this.state.dataCenter.map((entry, i) => (
														<Cell
															key={`cell-${i}`}
															fill={this.state.colorArray[(29+i) % this.state.colorArray.length   ]}
														/>
														))}
													</Bar>
													</BarChart>
											</ResponsiveContainer>
											</div>

											{/* LEGEND */}
											<div style={{ width: 180 }}>
											<ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
												{this.state.dataCenter.map((item, i) => (
												<li key={i} style={{ marginBottom: 8 }}>
													<span
													style={{
														display: "inline-block",
														width: 10,
														height: 10,
														backgroundColor:
														this.state.colorArray[
															(29+i) % this.state.colorArray.length  
														],
														marginRight: 8,
														borderRadius: "50%"
													}}
													/>
													<strong>{item.center}</strong>
													<span style={{ marginLeft: 6, color: "#666" }}>
													{item.total}
													</span>
												</li>
												))}
											</ul>
											</div>
										</div>
										</CardContent>
									</Card>
								</div>

								
							</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (StatisticalSummaryOfDonors);